<template>
  <div class="custom-ui-textbox-wrapper">
    <div class="custom-ui-textbox-label-row" v-if="label || info">
      <label :for="inputId" class="custom-ui-textbox-label" v-if="label" v-text="label" />
      <ui-field-info :text="info" />
    </div>
    <div class="custom-ui-textbox" :class="[style, disabled ? 'disabled' : '']">
      <textarea
        :id="inputId"
        v-model="model"
        :maxlength="maxLength > 0 ? maxLength : undefined"
        :disabled="disabled"
        :placeholder="placeholder"
      />
      <span class="custom-ui-textbox-counter" v-if="maxLength > 0">
        {{ model ? (model as string).length : 0 }} / {{ maxLength }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { IUITextbox } from '@/types/Components/UIKit'
  import { computed, useId } from 'vue'

  const {
    label = '',
    placeholder = '',
    maxLength = 0,
    hasValidation = false,
    anyError = false,
    disabled = false,
    info = '',
  } = defineProps<IUITextbox>()

  const model = defineModel<string | number | null>()

  const inputId = useId()

  const style = computed(() => {
    if (hasValidation) {
      return anyError ? 'danger' : 'success'
    } else {
      return ''
    }
  })
</script>

<style lang="scss" scoped>
  .custom-ui-textbox-wrapper {
    display: flex;
    width: 100%;
    flex-direction: column;
    .custom-ui-textbox-label-row {
      @include flexible($align: center, $wrap: wrap);
      gap: 0.35rem;
      margin-bottom: 0.5rem;
      .custom-ui-textbox-label {
        @include column-label($margin: 0);
        width: auto;
      }
    }
    .custom-ui-textbox {
      width: 100%;
      height: auto;
      border: 1px solid $border-color;
      border-radius: 5px;
      color: $primary-text-color;
      display: flex;
      position: relative;
      &.success {
        border-color: $success;
      }
      &.danger {
        border-color: $danger;
      }
      &.disabled textarea {
        cursor: not-allowed;
      }
      textarea {
        font-family: $font-family;
        width: 100%;
        height: 100%;
        padding: 0.5rem;
        resize: vertical;
        outline: none;
        border-radius: 5px;
        border: none;
        min-height: 100px;
        color: $primary-text-color;
        font-weight: 500;
      }
      .custom-ui-textbox-counter {
        position: absolute;
        background-color: #fff;
        right: 0.5rem;
        bottom: -0.325rem;
        z-index: 2;
        font-size: 0.625rem;
        padding: 0 0.25rem;
        color: #666;
      }
    }
  }
</style>
